import { render, staticRenderFns } from "./submissions.datatable.vue?vue&type=template&id=d2fbfcea&scoped=true&"
import script from "./submissions.datatable.vue?vue&type=script&lang=js&"
export * from "./submissions.datatable.vue?vue&type=script&lang=js&"
import style0 from "./submissions.datatable.vue?vue&type=style&index=0&id=d2fbfcea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fbfcea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
